import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M12.6 6a.6.6 0 1 0-1.2 0v6a.6.6 0 0 0 .332.537l4 2a.6.6 0 1 0 .537-1.074L12.6 11.63V6Z"
    />
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm8.8-10a8.8 8.8 0 1 1-17.6 0 8.8 8.8 0 0 1 17.6 0Z"
      clip-rule="evenodd"
    />
  </svg>
`;
